import { axiosInstance as axios } from '_utils'
import config from 'store/_config'

export const axiosUploadImages = async (file) => {
  if (file?.thumbnail) {
    return parseInt(file.id, 10)
  }

  let { url } = config.image.upload

  let formData = new FormData()

  if (typeof window.securityToken != 'undefined') {
    formData.set('SecurityID', window.securityToken)
  }

  formData.append('Upload', file)

  const response = await axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    withCredentials: true,
  })

  const imageID = response?.data?.ID

  return imageID
}
